export default __webpack_public_path__ + "static/media/Banner.2c0e34ad.jpg";